// hooks/usePrompt.ts
import { useContext, useEffect, useRef } from "react";
import { UNSAFE_NavigationContext as NavigationContext } from "react-router-dom";

export function usePrompt(message: string, when = true) {
    const { navigator } = useContext(NavigationContext);
    const isBlocking = useRef(false);

    useEffect(() => {
        if (!when) return;

        const originalPush = navigator.push;
        const originalReplace = navigator.replace;
        const originalGo = navigator.go;

        navigator.push = (...args) => {
            if (isBlocking.current) return;
            isBlocking.current = true;
            const result = window.confirm(message);
            isBlocking.current = false;

            if (result) {
                originalPush.apply(navigator, args);
            }
        };

        navigator.replace = (...args) => {
            if (isBlocking.current) return;
            isBlocking.current = true;
            const result = window.confirm(message);
            isBlocking.current = false;
            if (result) {
                originalReplace.apply(navigator, args);
            }
        };
        if (originalGo) {
            navigator.go = (...args) => {
                if (isBlocking.current) return;
                isBlocking.current = true;
                const result = window.confirm(message);
                isBlocking.current = false;
                if (result) {
                    originalGo.apply(navigator, args);
                }
            };
        }

        return () => {
            if (navigator.push !== originalPush) navigator.push = originalPush;
            if (navigator.replace !== originalReplace)
                navigator.replace = originalReplace;
            if (originalGo && navigator.go !== originalGo)
                navigator.go = originalGo;
        };
    }, [navigator, when, message]);
}
